<div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <h4 class="page-title">Update Article</h4>
        </div>
    </div>
</div>

<div class="card">
    <div class="card-body">
        <form [formGroup]="form">
            <div class="row">
                <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
                    <label for="simpleinput" class="form-label">Name*</label>
                    <input formControlName="name" type="text" id="simpleinput" class="form-control" placeholder="Name">
                </div>
               
            </div>

            <div class="row">
                <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
                    <label for="example-email" class="form-label">Unit of measurement*</label>
                    <input formControlName="unitOfMeasurement" type="text" id="example-email" class="form-control" placeholder="Unit of measurement">
                </div>
            </div>

            <div class="row">
                <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
                    <label for="example-email" class="form-label">Price*</label>
                    <input formControlName="price" type="text" id="example-email" class="form-control" placeholder="Price">
                </div>
            </div>

            <div class="row">
                <div class="mb-3 col-md-4 col-sm-10 col-xs-10" style="display: flex; align-items: center;">
                    <input formControlName="active" type="checkbox" class="form-check-input" id="customCheckcolor1" style="margin-right: 12px;">
                    <label class="form-check-label" for="customCheckcolor1">Active</label>
                </div>
                
            </div>
        </form>

        <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
            @if(submitting) {
                <button class="btn btn-secondary"  disabled>
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            } @else {
                <button class="btn btn-secondary" (click)="updateArticle()">
                    Update
                </button>
            }
            @if(error){<span class="p-2 text-danger">{{error}}</span>}
        </div>
    </div>
</div>